import React, { useState } from "react";

const SimList = ({ resourceItems, onItemClick, listIcon, counts, ...rest }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const handleItemClick = (index) => {
    setActiveIndex(index);
    if (onItemClick) {
      onItemClick(index, resourceItems[index]);
    }
  };

  return (
    <>
      <ul className="uilist">
        {resourceItems.map((item, index) => (
          <li
            className={activeIndex === index ? "sim-list-item active" : "sim-list-item"}
            key={index}
            onClick={() => handleItemClick(index)}
          >
            <span className="sim-list-title">
              {listIcon && item.icon}
              {item.title}
            </span>
            {counts && <span className="sim-list-count">{item.count}</span>}
          </li>
        ))}
      </ul>
    </>
  );
};

export default SimList;
